import { render } from "./HomeScoreView.vue?vue&type=template&id=8dd8f28c"
import script from "./HomeScoreView.vue?vue&type=script&lang=js"
export * from "./HomeScoreView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__